// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"cefcc207","453":"b425fb53"}[chunkId] + ".chunk.js";
};